import { render, staticRenderFns } from "./Loader2.vue?vue&type=template&id=3d4f21cc"
import script from "./Loader2.vue?vue&type=script&lang=js"
export * from "./Loader2.vue?vue&type=script&lang=js"
import style0 from "./Loader2.vue?vue&type=style&index=0&id=3d4f21cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports